import React from 'react';

import * as ChartGeo from "chartjs-chart-geo";
import {
  Chart as ChartJS,
  CategoryScale,
  Tooltip,
  Title,
  Legend
} from "chart.js";
import Map from "components/chart/geo-map";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  CategoryScale,
  ChartGeo.ChoroplethController,
  ChartGeo.ProjectionScale,
  ChartGeo.ColorScale,
  ChartGeo.GeoFeature
);

const ChartjsChartGeo = (props) => {

  return (
    <div style={{width:'60%',margin:'auto',marginTop:20}}>
      <Map chosenKey="united_states" data={props.data}/>
    </div>
  );
}

export default ChartjsChartGeo;